export default {
    name: 'spy',

    inserted(el, binding, { context }) {
        new ScrollMagic.Scene({
            triggerElement: el,
            triggerHook: 0,
            duration: el.clientHeight,
            offset: -80
        })
            .setClassToggle(el, 'is-active')
            .on('enter', _ => {
                el.classList.contains('is-active') && context.$emit('spy-detected', binding.value);
            })
            .on('leave', event => {
                const shouldStop = (binding.modifiers.first && event.scrollDirection === 'REVERSE') ||
                    (binding.modifiers.last && event.scrollDirection === 'FORWARD');

                shouldStop && context.$emit('spy-detected', '');
            })
            .addTo(context.$root.scrollMagicController)
    }
}